import React, { useCallback, useMemo } from "react";
import { compose } from "redux";

import withTranslations from "../../../../../hocs/withTranslations";
import {
  getStrategyDashboardEmptyStateTranslationKey,
  STRATEGY_DASHBOARD_EMPTY_STATE_TRANSLATION_KEY
} from "../../../../../lib/StrategyDashboard/strategyDashboardConfig";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import {
  formatNotificationCategoryLabels,
  getNotificationCategoryLabels
} from "../../../../../lib/notifications/getAlertCategoryLabel";
import NoNotificationsIcon from "../../../landingPage/pages/Notifications/assets/no-notifications.svg";
import showStrategyNotificationSettingsModal from "../utils/showStrategyNotificationSettingsModal";

const StrategyEnableNotificationsDesktop = ({
  translate,
  translationExists,
  locale,
  notificationTypes
}) => {
  const dashboard = useStrategyDashboardConfig();
  const titleKey = getStrategyDashboardEmptyStateTranslationKey(
    dashboard,
    STRATEGY_DASHBOARD_EMPTY_STATE_TRANSLATION_KEY.ENABLE_TITLE
  );
  const descriptionKey = getStrategyDashboardEmptyStateTranslationKey(
    dashboard,
    STRATEGY_DASHBOARD_EMPTY_STATE_TRANSLATION_KEY.ENABLE_DESCRIPTION
  );
  const buttonKey = getStrategyDashboardEmptyStateTranslationKey(
    dashboard,
    STRATEGY_DASHBOARD_EMPTY_STATE_TRANSLATION_KEY.ENABLE_BUTTON
  );

  const description = useMemo(
    () =>
      translate(descriptionKey, {
        notification_groups: formatNotificationCategoryLabels(
          getNotificationCategoryLabels(
            notificationTypes,
            translate,
            translationExists
          ),
          locale
        )
      }),
    [
      descriptionKey,
      locale,
      notificationTypes,
      translate,
      translationExists
    ]
  );

  const handleEnableClick = useCallback(() => {
    showStrategyNotificationSettingsModal({ translate, notificationTypes });
  }, [notificationTypes, translate]);

  return (
    <div className="flex flex-col justify-center align-center text-center max-w-82 mx-auto">
      <img src={NoNotificationsIcon} alt="" width={110} height={110} />
      <h2 className="text-base text-black font-bold mb-2">
        {translate(titleKey)}
      </h2>
      <p className="text-black-5 font-medium mb-6">{description}</p>
      <button
        type="button"
        className="button-4 border-none"
        onClick={handleEnableClick}
      >
        {translate(buttonKey)}
      </button>
    </div>
  );
};

export default compose(withTranslations)(StrategyEnableNotificationsDesktop);
